import Splide from '@splidejs/splide';
import {stripSplideSlideRoleAttributes} from './splideAccessibility';

const SELECTOR = '.events-slider__splide';

function initEventsSliderElement(element: HTMLElement): void {
    const splide = new Splide(element, {
        label: element.dataset.splideLabel || '',
        type: 'slide',
        fixedWidth: 246,
        perMove: 1,
        gap: '14px',
        drag: true,
        snap: true,
        arrows: false,
        pagination: false,
        mediaQuery: 'min',
        breakpoints: {
            768: {
                fixedWidth: 286,
                perMove: 1,
                gap: '24px',
            },
            992: {
                fixedWidth: 327,
                perMove: 1,
            },
        },
    }).mount();

    stripSplideSlideRoleAttributes(element);

    const carousel = element.closest('.events-slider__carousel');
    if (!carousel) return;

    const prevBtn = carousel.querySelector<HTMLButtonElement>('.events-slider__arrow--prev');
    const nextBtn = carousel.querySelector<HTMLButtonElement>('.events-slider__arrow--next');

    prevBtn?.addEventListener('click', () => splide.go('<'));
    nextBtn?.addEventListener('click', () => splide.go('>'));

    function getVisibleCount(): number {
        return element.querySelectorAll('.splide__slide:not([aria-hidden="true"])').length || 1;
    }

    function updateArrowState(): void {
        const visible = getVisibleCount();
        if (prevBtn) prevBtn.disabled = splide.index === 0;
        if (nextBtn) nextBtn.disabled = splide.index + visible >= splide.length;
    }

    splide.on('mounted move resize', updateArrowState);

    const liveRegion = document.createElement('div');
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    carousel.appendChild(liveRegion);

    splide.on('moved', (newIndex) => {
        liveRegion.textContent = `${newIndex + 1} von ${splide.length}`;
    });

    let dragStartX = 0;
    let dragMoved = false;
    const DRAG_THRESHOLD = 8;

    element.addEventListener('pointerdown', (e: PointerEvent) => {
        dragStartX = e.clientX;
        dragMoved = false;
    });
    element.addEventListener('pointermove', (e: PointerEvent) => {
        if (e.buttons === 0) return;
        if (Math.abs(e.clientX - dragStartX) > DRAG_THRESHOLD) dragMoved = true;
    });
    element.addEventListener('pointerup', () => { dragMoved = false; });
    element.addEventListener('pointercancel', () => { dragMoved = false; });
    element.querySelectorAll<HTMLAnchorElement>('.splide__slide a').forEach((link) => {
        link.addEventListener('click', (e) => { if (dragMoved) e.preventDefault(); });
    });
}

export function initEventsSlider(): void {
    document.querySelectorAll<HTMLElement>(SELECTOR).forEach(initEventsSliderElement);

    if (!document.body.classList.contains('neos-backend')) return;

    new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (!(node instanceof HTMLElement)) continue;
                if (node.matches(SELECTOR)) {
                    initEventsSliderElement(node);
                }
                node.querySelectorAll<HTMLElement>(SELECTOR).forEach(initEventsSliderElement);
            }
        }
    }).observe(document.body, { childList: true, subtree: true });
}
